import OrganizationsTable from "./OrganizationsTable";

const OrganizationsView = () => {
  return (
    <>
      <OrganizationsTable></OrganizationsTable>
    </>
  );
};
export default OrganizationsView;
